<template>
  <div class="text-textColor">
    <transition name="fade">
      <div v-if="recommendationTypes.length===0 && getUserType.toLowerCase() ==='hr manager'">
        <div
            class="p-1 text-center text-sm w-full bg-yellow-200"
        >
          The recommendations section is not setup yet. Contact the HR team for assistance
        </div>
      </div>
      <form v-else @submit.prevent="postRecommendation">
        <div
            v-if="showAddRecommendation"
            class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
        >
          <div
              class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full"
          >
            <div class="flex justify-between items-center border-b-1.5 p-3">
              <p class="text-base">Add Recommendation</p>
              <img
                  v-if="!loading"
                  class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
                  src="@/assets/icons/cross-white.png"
                  @click="close()"
              />
            </div>
            <transition name="fade">
              <div
                  v-if="create_error"
                  class="p-1 text-center text-sm w-full bg-yellow-200"
              >
                {{ create_error }}
              </div>
            </transition>
            <div class="grid grid-cols-1 p-4 gap-5">
              <div class="text-sm">
                <label class="block pb-1">Recommendation </label>
                <select
                    class="p-2 bg-gray-200 rounded-full w-full"
                    v-model="info.RecommendationTypeId"
                >
                  <option
                      v-for="option in recommendationTypes"
                      :key="option.RecommendationTypeId"
                      :value="option.RecommendationTypeId"
                  >
                    {{ option.Name }}
                  </option>
                </select>
              </div>

            </div>
            <div class="p-4">
              <label>Description</label>
              <textarea
                  class="p-1 bg-gray-200 rounded-xl w-full"
                  cols="5"
                  rows="5"
                  v-model="info.Description"
              ></textarea>
            </div>

            <div class="flex justify-end p-5">
              <button
                  class="bg-primary rounded-full px-10 text-sm text-white py-2"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </form>

    </transition>
  </div>
</template>

<script>
import decryptData from "@/utils/decrypt";
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: 'AddRecommendation',
  props: ["showAddRecommendation", "employeeNumber", "reviewPeriod", "reload"],
  components: {
  },
  data() {
    return {
      selectedType: "single",
      employees: [],
      create_error: null,
      info:{
        EmployeeId: this.employeeNumber,
        PerformancePeriodId: this.reviewPeriod,
        RecommendationTypeId: "",
        Description: ""
      },
      decryptDataLocal: "",
      decryptionKey: "",
      employeeNames: [],
      recommendationTypes:[],
      filters: [
        {
          nameAll: "Select all",
          nameNotAll: "Deselect all",
          func() {
            return true;
          },
        },
        {
          nameAll: "select <= 10",
          nameNotAll: "Deselect <= 10",
          func(elem) {
            return elem.name <= 10;
          },
        },
        {
          nameAll: "Select contains 2",
          nameNotAll: "Deselect contains 2",
          func(elem) {
            return elem.name.indexOf("2") !== -1;
          },
        },
      ],
      options: {
        multi: true,
        groups: true,
      },
    };
  },
  created() {
    this.decryptDataLocal = decryptData;
    this.decryptionKey = this.$decryptionKey;
    this.getRecommendationTypes()
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken", "getUserType"]),
  },
  methods: {
    close() {
      this.$emit("close");
    },
    getRecommendationTypes() {
      this.loading = true;
      let url = `${this.getOrganization}/performance/recommendation/type/${this.$ApiVersion}/request`;

      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(url, options).then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {

              this.recommendationTypes = response.data.Data;
            } else {

              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
      );
    },
    postRecommendation(){
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      axios
          .post(
              `${this.getOrganization}/performance/recommendation/${this.$ApiVersion}/create`,
              JSON.stringify(this.info),
              options
          )
          .then(
              (response) => {
                if (response.data.StatusCode===200){
                  this.$notify.success({
                    title: "Success",
                    message: response.data.StatusMessage,
                  });
                  this.reload()
                  close()
                }
                else {
                  this.$notify.error({
                    title: "Failure",
                    message: response.data.StatusMessage,
                  });
                  this.create_error = response.data.StatusMessage;
                }
              },
              (error) => {
                console.log(error)
              })
    }
  },
};
</script>

<style>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.select > button[data-v-0ea235da] {
  width: 100% !important;
}
</style>
